export default __webpack_public_path__ + "static/breezy-logo-614ecc689849a5731d2e976bcb9fd3bd.png";